const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const upsertVentasPeriodo = async (data) => {
  const res = await fetch(`${API_URL}/ventas-periodo/upsert`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Error al guardar las ventas del período');
  return res.json();
};

export const getVentasByPeriodo = async (periodo) => {
  const res = await fetch(`${API_URL}/ventas-periodo/by-periodo/${periodo}`);
  if (!res.ok) throw new Error('Error al obtener las ventas del período');
  return res.json();
};

export const fetchPeriodos = async ({ limit = 24, offset = 1 } = {}) => {
  const res = await fetch(`${API_URL}/ventas-periodo/filter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ limit, offset }),
  });
  if (!res.ok) throw new Error('Error al listar los períodos');
  return res.json();
};

export const deleteVentasPeriodo = async (id) => {
  const res = await fetch(`${API_URL}/ventas-periodo/delete/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Error al eliminar el período');
  return res.json();
};
